import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import { FaEye, FaEyeSlash } from "react-icons/fa"
import { useMobileDetection } from "../../../shared/hooks/useMobileDetection"
import { authLogin } from "../api/auth.api"
import { CONST_KEY_USUARIO_AUTENTICADO, CONST_PARAMETRO_SISTEMA_SEGURIDAD } from "../../../app/constants/constanst-valores"

import { Alert, Button, Input } from "../../../shared/ui"
import { cambiarColores, encriptar, guardarLocalStorage, limpiarLocalStorage } from "../../../shared/utils/funciones"
import { configColoresCompaniaSUPERADMIN } from "../../../app/constants/config-colores-compania-superadmin"

import { CONST_RUTA_USUARIOS_LISTAR } from "../../../app/constants/constants-rutas-codigos"

export const Login = () => {

    const imagen = "/img/logo-seguridad.png"
    const logoUser = "/img/logo-user.png"

    const [mensaje, setMensaje] = useState('')
    const [mostrarError, setMostrarError] = useState(false)
    const [cargando, setCargando] = useState(false)
    const [verPassword, setVerPassword] = useState(false)

    const isMobile = useMobileDetection()

    const { register, handleSubmit } = useForm({
        defaultValues: {
            user: "",
            password: "",
        }
    });

    const navigate = useNavigate()

    const onLogin = async (data) => {

        setMostrarError(false)
        setCargando(true)

        const dataPOST = {
            user: data?.user,
            password: data?.password,
            parametro: CONST_PARAMETRO_SISTEMA_SEGURIDAD
        }

        const dataPOSTEncriptado = {
            body: encriptar(dataPOST)
        }

        const { resEncriptado, usuario, status, message } = await authLogin(dataPOSTEncriptado)
        //console.log("el mensaje es: ",message)
        setMensaje(message)

        if (status === 1) {

            guardarLocalStorage(resEncriptado, CONST_KEY_USUARIO_AUTENTICADO)
            //Obtener los estilos de la pagina de cada compania
            const estilosCompania = usuario?.estilo;

            // Guardar los colores al cargar la pagina
            if (estilosCompania) {

                const colores = [
                    { name: '--color-fondo-menu-primario', color: estilosCompania?.fondo_menu },
                    { name: '--color-texto-nav-item', color: estilosCompania?.text_opciones },
                    { name: '--color-fondo-nav-item-activo', color: estilosCompania?.fond_opc_activo },
                    { name: '--color-texto-nav-item-activo', color: estilosCompania?.text_opc_activo },
                    { name: '--color-button-primario', color: estilosCompania?.boton_primario },
                    { name: '--color-button-primario-hover', color: estilosCompania?.boton_primario_activo },
                    { name: '--color-button-primario-text', color: estilosCompania?.text_boton_primario },
                    { name: '--color-button-secundario', color: estilosCompania?.boton_secundario },
                    { name: '--color-button-secundario-hover', color: estilosCompania?.boton_secundario_activo },
                    { name: '--color-button-secundario-text', color: estilosCompania?.text_boton_secundario },
                ];

                cambiarColores(colores);
            }else{
                const colores = [
                    { name: '--color-fondo-menu-primario', color: configColoresCompaniaSUPERADMIN?.CONST_COLOR_FONDO_MENU_PRIMARIO },
                    { name: '--color-texto-nav-item', color: configColoresCompaniaSUPERADMIN?.CONST_COLOR_TEXTO_NAV_ITEM },
                    { name: '--color-fondo-nav-item-activo', color: configColoresCompaniaSUPERADMIN?.CONST_FONDO_NAV_ITEM_ACTIVO },
                    { name: '--color-texto-nav-item-activo', color: configColoresCompaniaSUPERADMIN?.CONST_TEXTO_NAV_ITEM_ACTIVO },
                    { name: '--color-button-primario', color: configColoresCompaniaSUPERADMIN?.CONST_COLOR_BUTTON_PRIMARIO },
                    { name: '--color-button-primario-hover', color: configColoresCompaniaSUPERADMIN?.CONST_COLOR_BUTTON_PRIMARIO_HOVER },
                    { name: '--color-button-primario-text', color: configColoresCompaniaSUPERADMIN?.CONST_COLOR_BUTTON_PRIMARIO_TEXT },
                    { name: '--color-button-secundario', color: configColoresCompaniaSUPERADMIN?.CONST_COLOR_BUTTON_SECUNDARIO },
                    { name: '--color-button-secundario-hover', color: configColoresCompaniaSUPERADMIN?.CONST_COLOR_BUTTON_SECUNDARIO_HOVER },
                    { name: '--color-button-secundario-text', color: configColoresCompaniaSUPERADMIN?.CONST_COLOR_BUTTON_SECUNDARIO_TEXT},
                ];
                cambiarColores(colores);
            }
            navigate(CONST_RUTA_USUARIOS_LISTAR)
        } else {

            setCargando(false)
            setMostrarError(true)
        }
    }

    useEffect(() => {
        limpiarLocalStorage(CONST_KEY_USUARIO_AUTENTICADO)
    }, [])


    return (
        <div className="tw-flex tw-min-h-screen tw-bg-menu-primario">
            {/* Panel del formulario */}
            <div className="tw-flex tw-w-full tw-items-center tw-justify-center tw-p-6 lg:tw-w-1/2">
                <div className="tw-w-full tw-max-w-sm tw-rounded-2xl tw-bg-white tw-p-8 tw-shadow-2xl">
                    <div className="tw-mb-6 tw-flex tw-flex-col tw-items-center tw-text-center">
                        <img src={logoUser} alt="logo-user" className="tw-mb-3 tw-h-16 tw-w-auto" />
                        <h1 className="tw-text-2xl tw-font-semibold tw-text-menu-primario">Sistema de Seguridad</h1>
                        <p className="tw-mt-1 tw-text-sm tw-text-gray-500">Inicia sesión para continuar</p>
                    </div>

                    <form onSubmit={handleSubmit(onLogin)} className="tw-space-y-4">
                        <div>
                            <label htmlFor="login-user" className="tw-mb-1 tw-block tw-text-sm tw-font-medium tw-text-gray-700">Usuario</label>
                            <Input id="login-user" type="text" {...register("user")} placeholder="Ingrese su usuario" style={{ textTransform: "none", height: "42px" }} />
                        </div>
                        <div>
                            <label htmlFor="login-pass" className="tw-mb-1 tw-block tw-text-sm tw-font-medium tw-text-gray-700">Contraseña</label>
                            <div className="tw-relative">
                                <Input id="login-pass" type={verPassword ? "text" : "password"} {...register("password")} placeholder="Ingrese su contraseña" className="tw-pr-10" style={{ textTransform: "none", height: "42px" }} />
                                <button
                                    type="button"
                                    onClick={() => setVerPassword((v) => !v)}
                                    aria-label={verPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                    title={verPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                    className="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-flex tw-items-center tw-justify-center tw-bg-transparent tw-border-0 tw-p-0 tw-text-gray-500 hover:tw-text-menu-primario tw-cursor-pointer"
                                >
                                    {verPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                        </div>
                        <Button variant="primary" size="md" type="submit" disabled={cargando} className="tw-w-full disabled:tw-opacity-70 disabled:tw-cursor-not-allowed">
                            {
                                cargando ? (
                                    <span className="tw-inline-flex tw-items-center tw-gap-2">
                                        <span className="tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-white tw-border-t-transparent" />
                                        Iniciando sesión…
                                    </span>
                                ) : "Iniciar Sesión"
                            }
                        </Button>
                        {
                            mostrarError && (
                                <Alert severity="warning" className="tw-mt-2">{mensaje}</Alert>
                            )
                        }
                    </form>
                </div>
            </div>

            {/* Panel de ilustración (oculto en móvil) */}
            {
                !isMobile && (
                    <div className="tw-hidden tw-w-1/2 tw-items-center tw-justify-center tw-bg-white tw-p-8 lg:tw-flex">
                        <img src={imagen} alt="Ilustración de seguridad" className="tw-max-h-[90vh] tw-w-full tw-object-contain" />
                    </div>
                )
            }
        </div>
    );
};


